import { FC } from "react";
import Stack from "@mui/material/Stack";
import { Box, Divider, LinearProgress } from "@mui/material";
import { BudgetDetailsMainHeader } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/header/BudgetDetailsMainHeader";
import { BudgetDetailsSubHeader } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/header/BudgetDetailsSubHeader";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";
import { budgetDetailsAccumulatedCostLoadingSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsAccumulatedCostLoadingSelector";

export const BudgetDetailsHeader: FC = () => {
  const detailsLoading = useAppSelector(budgetDetailsByIdLoadingSelector);
  const accumulatedCostLoading = useAppSelector(
    budgetDetailsAccumulatedCostLoadingSelector,
  );
  const loading = detailsLoading || accumulatedCostLoading;

  return (
    <Stack position="sticky" top={0} bgcolor="white">
      <BudgetDetailsMainHeader />
      <BudgetDetailsSubHeader />
      <Divider />

      {loading && (
        <Box position="absolute" top="100%" left={0} right={0}>
          <LinearProgress />
        </Box>
      )}
    </Stack>
  );
};
